import React from 'react';
import CabPageShell from './CabPageShell';

const AdminCabsCoupons = () => (
  <CabPageShell
    title="Coupons"
    description="Create discount codes for cab services and packages."
  />
);

export default AdminCabsCoupons;
